module.exports = "/_next/static/images/b3b33a9941042f243b4aaac2a40a2110-xpeer-fgts@0.75x.jpg";